<template>
  <div class="search-form px-2">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
    >
      <div class="row nopads">
        <div class="col-sm-4">
          <span class="span-title">{{ $t('bridge.road_num') }}</span>
          <input
            id="road_num"
            v-model="roadNumber"
            class="form-control form-control-sm"
            type="number"
          >
        </div>

        <div class="col-sm-4">
          <span class="span-title">{{ $t('trip_list.search_with_road_sec') }}</span>
          <input
            id="roadSecFrom"
            v-model="roadSecFrom"
            :placeholder="$t('trip_list.road_sec_from')"
            class="form-control form-control-sm"
            type="number"
          >
        </div>

        <div class="col-sm-4">
          <span class="span-title">{{ $t('trip_list.search_with_road_sec') }}</span>
          <input
            id="roadSecTo"
            v-model="roadSecTo"
            :placeholder="$t('trip_list.road_sec_to')"
            class="form-control form-control-sm"
            type="number"
          >
        </div>
      </div>
      <div class="col-sm-12 button-container">
          <button
              type="reset"
              class="form-button btn btn-danger"
          >
              {{ $t('ins_report.clear') }}
          </button>
          <button
              class="form-button btn btn-primary"
              @click.stop="fetchNearest"
          >
              {{ $t('bridge.search_nearest') }}
          </button>
          <button
              type="submit"
              class="form-button btn btn-primary"
          >
              {{ $t('ins_report.search') }}
          </button>
      </div>
    </form>
  </div>
</template>

<script>

import {inject} from "vue";

export default {
    name: 'CulvertSearch',
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            roadNumber: null,
            roadSecFrom: null,
            roadSecTo: null,
            userPosition: null
        }
    },
    created() {
        this.initPosition()
        this.watchUserPosition()
    },
    methods: {
        onSubmit: function () {
            let params = {}
            if (!this.roadNumber) {
                this.showAlert(this.$t('bridge.input_road_num'))
                return
            } else {
                params.roadnum = this.roadNumber
            }
            if (this.roadSecFrom) {
                params.road_sec_from = this.roadSecFrom
            }
            if (this.roadSecTo) {
                params.road_sec_to = this.roadSecTo
            }
            this.$emit('search', params)
        },
        fetchNearest: function () {
            if (this.userPosition) {
                this.$emit('search', {
                    lat: this.userPosition.coords.latitude,
                    lon: this.userPosition.coords.longitude
                })
            } else {
                this.showAlert(this.$t('bridge.fetching_location'))
            }
        },
        initPosition: function () {
            navigator.geolocation.getCurrentPosition(pos => this.setPosition(pos))
        },
        setPosition: function (position) {
            this.userPosition = position
        },
        watchUserPosition: function () {
            if (navigator.geolocation) {
                this.watchID = navigator.geolocation.watchPosition(position => {
                    this.setPosition(position)
                }, () => {
                }, {timeout: 30000, enableHighAccuracy: true})
            }
        },
    }
}
</script>
